/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of assets consolidated. The values can be ESS, MACHINE, CHARGER, CHARGING_STATION, and ENERGY_SOURCE. By default, it is MACHINE.
 */
export var AssetSourceTypeForUpdate;
(function (AssetSourceTypeForUpdate) {
    AssetSourceTypeForUpdate["MACHINE"] = "MACHINE";
    AssetSourceTypeForUpdate["ESS"] = "ESS";
    AssetSourceTypeForUpdate["CHARGER"] = "CHARGER";
    AssetSourceTypeForUpdate["CHARGING_STATION"] = "CHARGING_STATION";
    AssetSourceTypeForUpdate["ENERGY_SOURCE"] = "ENERGY_SOURCE";
})(AssetSourceTypeForUpdate || (AssetSourceTypeForUpdate = {}));
